// extracted by mini-css-extract-plugin
module.exports = {"itemTextContainer":"TwHrhR","itemEmptyListText":"c0Smyo7","itemBasketIcon":"hmL3OQ","titleTextField":"c-vaIcV","itemCountTextField":"ggdxh_"};